import useFetcher from "@/utils/use-fetcher";
import { useMemo } from "react";
import { AxiosRequestConfig } from "axios";
import {
  getListOrderSheetRevisionsV2Key,
  ListOrderSheetRevisionsV2Request,
  ListOrderSheetRevisionsV2Response, parseListOrderSheetRevisionsV2Key
} from "@/features/order-sheet-sets/hooks/use-list-order-sheet-revisions-v2";

export default function useListOrderSheetRevisionsFetcherV2() {
  const listOrderSheetRevisionsFetcherV2 = useFetcher<
    ListOrderSheetRevisionsV2Request,
    ListOrderSheetRevisionsV2Response
  >();

  return useMemo(() => {
    return async (
      config: AxiosRequestConfig<ListOrderSheetRevisionsV2Request>
    ): Promise<ListOrderSheetRevisionsV2Response> => {
      const { parameter, request } = parseListOrderSheetRevisionsV2Key(config);
      if (parameter.orderSheetSetId > -1) {
        const listOrderSheetRevisionsResponse =
          await listOrderSheetRevisionsFetcherV2(
            getListOrderSheetRevisionsV2Key(parameter, request)!
          );

        if (listOrderSheetRevisionsResponse.revisions.length > 0) {
          return Promise.resolve({
            totalCount: listOrderSheetRevisionsResponse.totalCount,
            revisions: listOrderSheetRevisionsResponse.revisions,
          });
        }
      }
      return Promise.resolve({
        totalCount: 0,
        revisions: [],
      });
    };
  }, [listOrderSheetRevisionsFetcherV2]);
}
